export const setUploadQueue = (state, payload) => {
  state.uploadQueue = payload
}

export const addToUploadQueue = (state, payload) => {
  const incomingNames = new Set(payload.map((media) => media.file.name))

  state.uploadQueue = state.uploadQueue
    .filter((media) => !(media.status === "rejected" && incomingNames.has(media.file.name)))
    .concat(payload)
}

export const updateQueuedMedia = (state, { media, fields }) => {
  const index = state.uploadQueue.findIndex((m) => m.id === media.id)

  if (state.uploadQueue[index]) {
    for (const [key, value] of Object.entries(fields)) {
      state.uploadQueue[index][key] = value
    }
  }
}

export const removeFinishedUploads = (state) => {
  state.uploadQueue = state.uploadQueue.filter((media) => !["success", "canceled"].includes(media.status))
}

export const setUploadAbortController = (state, payload) => {
  state.uploadAbortController = payload
}
